import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import WrapperPage from "../../components/WrapperPage";
import BaseButton from "../../components/BaseButton";
import InsightFormProtect from "../../hocs/InsightFormProtect";
import useBrowserStorage from "../../hooks/useBrowserStorage";
import { INSIGHT_INSTRUCTION_READ } from "../../utils/constants";
import ROUTES from "../../utils/routes.js";
import "./style.scss";

export default InsightFormProtect(function InsightFormInstructionPage() {
  const { t } = useTranslation();
  const { setItem } = useBrowserStorage();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    setItem(INSIGHT_INSTRUCTION_READ, 1);
  }, []);
  return (
    <div className="insight_form_instruction_page centering-page">
      <WrapperPage
        headerTitle={t("insight_form_instruction_page.title")}
        backBtn
        burgerMenu
      >
        <div className="insight_form_instruction_page__subtitles">
          <div className="insight_form_instruction_page__subtitle-1">
            {t("insight_form_instruction_page.subtitle_1")}
          </div>
          <div className="insight_form_instruction_page__subtitle-2">
            {t("insight_form_instruction_page.subtitle_2")}
          </div>
        </div>

        <div className="insight_form_instruction_page__blocks">
          <div className="insight_form_instruction_page__top-blocks">
            <div className="insight_form_instruction_page__left-blocks">
              <div className="insight_form_instruction_page__block">
                <div className="insight_form_instruction_page__block-number">
                  1
                </div>
                <div className="insight_form_instruction_page__block-desc">
                  {t("insight_form_instruction_page.block_one")}
                </div>
              </div>
              <div className="insight_form_instruction_page__block">
                <div className="insight_form_instruction_page__block-number">
                  2
                </div>
                <div className="insight_form_instruction_page__block-desc">
                  {t("insight_form_instruction_page.block_two")}
                </div>
              </div>
              <div className="insight_form_instruction_page__block">
                <div className="insight_form_instruction_page__block-number">
                  3
                </div>
                <div className="insight_form_instruction_page__block-desc">
                  {t("insight_form_instruction_page.block_three")}
                </div>
              </div>
            </div>
            <div className="insight_form_instruction_page__right-blocks">
              <div className="insight_form_instruction_page__right-blocks-warn">
                {t("insight_form_instruction_page.warning")}
              </div>
              <div className="insight_form_instruction_page__right-blocks-desc">
                {t("insight_form_instruction_page.block_warning.desc1")}
              </div>
              <div className="insight_form_instruction_page__right-blocks-desc">
                {t("insight_form_instruction_page.block_warning.desc2")}
              </div>
              <div className="insight_form_instruction_page__right-blocks-desc">
                {t("insight_form_instruction_page.block_warning.desc3")}
              </div>
            </div>
          </div>
          <div className="insight_form_instruction_page__bottom-block">
            <div className="insight_form_instruction_page__block-number">4</div>
            <div className="insight_form_instruction_page__block-desc">
              {t("insight_form_instruction_page.block_four")}
            </div>
          </div>
        </div>

        <div className="insight_form_instruction_page__final-text insight_form_instruction_page__final-text-1">
          {t("insight_form_instruction_page.finalText1")}
        </div>
        <div className="insight_form_instruction_page__final-text insight_form_instruction_page__final-text-1">
          {t("insight_form_instruction_page.finalText2")}
        </div>

        <div className="insight_form_instruction_page__see-button">
          <BaseButton
            onClick={() => {
              if (location?.state?.formId) {
                navigate(
                  ROUTES.INSIGHT_QUESTIONNAIRE_FORM_PAGE(
                    location.state?.formId,
                  ),
                  {
                    state: location.state,
                  }
                );
              } else {
                navigate(ROUTES.INSIGHT_QUESTIONNAIRE_PAGE);
              }
            }}
          >
            {t("insight_form_instruction_page.start")}
          </BaseButton>
        </div>
      </WrapperPage>
    </div>
  );
});
